import { v4 as uuidv4 } from "uuid";
import { AUTO_SAVE_STATUS } from "src/components/collections/knowledge-sources/explore/ExploreTab.consts";

// Inline "+ Add New" rows are client-only until complete. They live here (keyed by schema type)
// rather than in the tab component so they survive switching between collection tabs; they are
// cleared on reload (not persisted) and when leaving the page via the unsaved-changes blocker.
const createExploreAutoSaveSlice = (set) => ({
  exploreSaveStatus: AUTO_SAVE_STATUS.IDLE,
  setExploreSaveStatus: (status) => set({ exploreSaveStatus: status }),
  resetExploreSaveStatus: () => set({ exploreSaveStatus: AUTO_SAVE_STATUS.IDLE }),
  explorePendingRows: {},
  addExplorePendingRow: (schemaType) =>
    set((state) => ({
      explorePendingRows: {
        ...state.explorePendingRows,
        [schemaType]: [...(state.explorePendingRows[schemaType] ?? []), { tempId: uuidv4(), values: {} }]
      }
    })),
  updateExplorePendingRow: (schemaType, tempId, values) =>
    set((state) => ({
      explorePendingRows: {
        ...state.explorePendingRows,
        [schemaType]: (state.explorePendingRows[schemaType] ?? []).map((row) =>
          (row.tempId === tempId ? { ...row, values } : row))
      }
    })),
  removeExplorePendingRow: (schemaType, tempId) =>
    set((state) => ({
      explorePendingRows: {
        ...state.explorePendingRows,
        [schemaType]: (state.explorePendingRows[schemaType] ?? []).filter((row) => row.tempId !== tempId)
      }
    })),
  clearExplorePendingRows: () => set({ explorePendingRows: {} })
});

export default createExploreAutoSaveSlice;
